import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";
import OrderModal from "./OrderModal";
import PopupCard from "./PopupCard";
import { t } from "../i18n";
import "./NavBar.css";

function bold(s, className = "nav-elem") {
  return <b className={className}>{s}</b>;
}

function NavBar({ lang = "pt" }) {
  const [scrolling, setScrolling] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);
  const navigate = useNavigate();

  const isMenuPage = window.location.pathname.match(/\/menu(\/?|$)/);

  // Scroll & resize detection
  useEffect(() => {
    const handleScroll = () => setScrolling(window.scrollY > 50);
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !toggleRef.current.contains(e.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const title = (
    <span
      style={{ cursor: "pointer" }}
      onClick={() => {
        setIsMenuOpen(false);
        navigate(`/${lang}`);
      }}
    >
      <img
        src="https://p02--yoyobackend--vkm66xzdp2ty.code.run/media/Final_Logo-removebg-preview.png"
        alt="logo"
        id="logo"
      />
    </span>
  );

  const menu = bold(t(lang, "menu").toUpperCase());
  const about = bold(lang === "en" ? "ABOUT US" : "SOBRE NÓS");
  const contact = bold(lang === "en" ? "CONTACT" : "CONTACTO");

  return (
    <>
      <Navbar
        id="navigationBar"
        collapseOnSelect
        fixed="top"
        expand="lg"
        className={`${scrolling || isMenuPage ? "scrolled" : ""} ${
          scrolling && isMobile ? "scrolled-mobile" : ""
        }`}
      >
        <Container>
          <Navbar.Brand href="#home">{title}</Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={toggleMenu}
            className={isMenuOpen ? "open" : ""}
            ref={toggleRef}
          />
          <Navbar.Collapse
            id="basic-navbar-nav"
            ref={menuRef}
            in={isMenuOpen}
            className={isMobile ? "mobile-menu" : ""}
          >
            <Nav className="me-auto">
              <Nav.Link
                onClick={() => {
                  setIsMenuOpen(false);
                  if (window.location.pathname === `/${lang}/menu`) {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  } else {
                    navigate(`/${lang}/menu`);
                  }
                }}
              >
                {menu}
              </Nav.Link>
              <Nav.Link
                onClick={() => {
                  setIsMenuOpen(false);
                  if (isMenuPage) navigate(`/${lang}#about`);
                  else window.location.hash = "#about";
                }}
              >
                {about}
              </Nav.Link>
              <Nav.Link
                onClick={() => {
                  setIsMenuOpen(false);
                  if (isMenuPage) navigate(`/${lang}#contact`);
                  else window.location.hash = "#contact";
                }}
              >
                {contact}
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link as="span">
                <button
                  className="cta-btn"
                  onClick={() => setShowOrderModal(true)}
                >
                  {lang === "en" ? "Order Now" : "Encomendar"}
                </button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <OrderModal
        show={showOrderModal}
        onHide={() => setShowOrderModal(false)}
        lang={lang}
      >
        <PopupCard
          imgSrc="/assets/ubereats.png"
          alt="Uber Eats"
          name="Uber Eats"
          href="https://www.ubereats.com/pt/store/yo-yo-kebab-e-pizzas/We7eG4JUUPqw2bvh8CcjxA?diningMode=DELIVERY&surfaceName="
        />
        <PopupCard
          imgSrc="/assets/aviatelogonovo.png"
          alt="Avia-te"
          name="Avia-te"
          href="https://aviate.pt/categoria/yoyo-kebab-e-pizzas/"
        />
      </OrderModal>
    </>
  );
}

export default NavBar;
